/**
 * Linkable Parties
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const LinkablePartiesActions = {
  async getLinkableParties (_, params) {
    return axiosRequest.
      get(`/parties/${params.partyId}/linkable_parties`, {
        params: {
          items_per_page: params.itemsPerPage || 20,
          page: params.page || 1,
          search_term: params.searchTerm || '',
          sort_by: params.sortBy || '',
          sort_order: params.sortDesc ? 'desc' : 'asc',
        },
      }).
      then(({ data }) => ({
        items: data.items,
        itemsPerPage: data.items_per_page,
        page: data.page,
        pageCount: data.page_count,
        pageStart: data.page_start,
        pageStop: data.page_stop,
        sortBy: data.sort_by,
        sortDesc: data.sort_order === 'desc',
        totalItems: data.total_items,
      })).
      catch(handleError)
  },
}
